import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { is } from 'utils/is';

const firebaseConfig = is.localhost
  ? {
      apiKey: 'AIzaSyAXXUElp30hoMTQpdjCULFHeBgs3c1lQhA',
      authDomain: 'financial--storage.firebaseapp.com',
      projectId: 'financial-secure-storage',
      storageBucket: 'financial-secure-storage.firebasestorage.app',
      messagingSenderId: '799279169815',
      appId: '1:799279169815:web:c202719da37c4421243752',
      measurementId: 'G-DXRTQQ3PLT',
    }
  : is.dev
    ? {
        apiKey: 'AIzaSyAXXUElp30hoMTQpdjCULFHeBgs3c1lQhA',
        authDomain: 'financial--storage.firebaseapp.com',
        projectId: 'financial-secure-storage',
        storageBucket: 'financial-secure-storage.firebasestorage.app',
        messagingSenderId: '799279169815',
        appId: '1:799279169815:web:c202719da37c4421243752',
        measurementId: 'G-DXRTQQ3PLT',
      }
    : is.prod
      ? {
          apiKey: 'AIzaSyC9bzt0iHAbtp0f-hhC6p35QvexZw_S6rQ',
          authDomain: 'rocky.firebaseapp.com',
          projectId: 'financial--storage-prod',
          storageBucket: 'financial--storage-prod.appspot.com',
          messagingSenderId: '1068475312338',
          appId: '1:1068475312338:web:5520aa5a09219a7cf4650b',
          measurementId: 'G-RXXNM13L69',
        }
      : null;

if (!firebaseConfig) {
  throw new Error('Invalid environment');
}

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
